import { render, staticRenderFns } from "./OwnInfoEditView.vue?vue&type=template&id=6029040b&"
import script from "./OwnInfoEditView.vue?vue&type=script&lang=ts&"
export * from "./OwnInfoEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports